import React, { FC } from 'react';
import { ForgeButton, ForgeIcon, ForgeToolbar } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';
import { useError } from '../../context/errorContext';

const scope = 'shared.components.schedule_send_report.modal';

interface FooterProps {
  onDismiss: () => void;
  onSaveConfiguration: () => void;
  onUpdate: () => void;
  currentMode: string;
}

const Footer: FC<FooterProps> = ({ onDismiss, onSaveConfiguration, onUpdate, currentMode }) => {
  const { formButtonsDisabled } = useError();

  return (
    <ForgeToolbar inverted={true} className="footer-toolbar" data-testid="footer-toolbar">
      <div slot="end">
        <ForgeButton variant="outlined" id="cancel-button" onClick={onDismiss}>
          {I18n.t('cancel', { scope })}
        </ForgeButton>
        {currentMode != 'edit' ? (
          <ForgeButton
            variant="raised"
            id="save-button"
            onClick={onSaveConfiguration}
            data-testid="save-button"
            disabled={formButtonsDisabled}
          >
            <ForgeIcon name="send_clock" aria-hidden="false" external external-type="extended"></ForgeIcon>
            {I18n.t('title', { scope })}
          </ForgeButton>
        ) : (
          <ForgeButton
            variant="raised"
            id="update-button"
            onClick={onUpdate}
            data-testid="update-button"
            disabled={formButtonsDisabled}
          >
            {I18n.t('save', { scope })}
          </ForgeButton>
        )}
      </div>
    </ForgeToolbar>
  );
};

export default Footer;
